import request from "@/utils/request";
import url from "postcss-url";

// -------------------------------------------------------------- 农作物 -------------------------------------------------------------- //

// 发送手机验证码
export function sendSmsCode(data) {
  return request({
    url: "/admin-api/system/auth/send-sms-code",
    method: "POST",
    data,
    // noTen: 1
  });
}

// 获取租户ID
export function GetTenanId(params) {
  return request({
    url: '/admin-api/system/tenant/get-id-by-name',
    method: 'GET',
    params,
    noTen: 1
  })
}

//注册
export function register(data) {
  return request({
    url: '/admin-api/system/tenant/creates',
    method: "POST",
    data,
    noTen: 1
  })
}


// 短信验证码注册-登录
export function smsLogin(data) {
  return request({
    url: "/admin-api/system/auth/sms-login",
    method: "POST",
    data,
    noTen: 1
  });
}

// 短信验证码注册-登录
export function smsLogins(data) {
  return request({
    url: "/admin-api/system/auth/login",
    method: "POST",
    data,
    noTen: 1
  });
}
// 所属行业-分页
export function zidianPages(params) {
  return request({
    url: "/admin-api/web/zidian/pages",
    method: "GET",
    params
  });
}
// 获得登录用户的菜单列表
export function listMenus(params) {
  return request({
    url: "/admin-api/system/auth/list-menus",
    method: "GET",
    params
  });
}

// 获取登录用户信息
export function profileGet(params) {
  console.log(params)
  return request({
    url: "/admin-api/system/user/profile/get",
    method: "GET",
    params,
  });
}
// 获取登录用户信息
export function profileGets(params) {
  console.log(params)
  return request({
    url: "/admin-api/system/user/profile/gets",
    method: "GET",
    params,
  });
}

// 企业基本信息
export function enterPage(params) {
  return request({
    url: "/admin-api/web/enter/gets",
    method: "GET",
    params
  });
}

//企业新增信息
export function create(data) {
  return request({
    url: '/admin-api/web/enter/create',
    method: "POST",
    data
  })
}

//修改下载次数和IM次数
export function setnumber(params) {
  return request({
    url: '/admin-api/web/enter/updates',
    method: 'PUT',
    params
  })
}

// 职位中心
export function positionPage(params) {
  return request({
    url: "/admin-api/web/position/pagea",
    method: "GET",
    params
  });
}

// 职位中心置顶
export function positionTop(params) {
  return request({
    url: "/admin-api/web/position/top",
    method: "GET",
    params
  });
}

// 职位中心-上下架
export function positionUpdate(data) {
  return request({
    url: "/admin-api/web/position/update",
    method: "PUT",
    data
  });
}

// 职位中心-详情
export function positionGet(params) {
  return request({
    url: "/admin-api/web/position/get",
    method: "GET",
    params
  });
}


// 获取全部职位--下拉
export function positionPost(params) {
  return request({
    url: "/admin-api/web/position/post",
    method: "GET",
    params
  });
}

// 获取热门职位
export function positionLogHots(params) {
  return request({
    url: "/admin-api/web/position-log/hots",
    method: "GET",
    params
  });
}

// 我的收藏分页
export function collectList(params) {
  return request({
    url: "/admin-api/web/collect/page",
    method: "GET",
    params
  });
}

// 收藏操作
export function collectCreate(params) {
  return request({
    url: "/admin-api/web/collect/create",
    method: "POST",
    params
  });
}

// 取消收藏
export function collectDelete(params) {
  return request({
    url: "/admin-api/web/collect/delete",
    method: "delete",
    params
  });
}

// 搜索人才分页
export function seekersSearchPage(params) {
  return request({
    url: "/admin-api/web/seekers/searchPage",
    method: "GET",
    params
  });
}

// 面试邀请分页
export function interviewSearchPage(params) {
  return request({
    url: "/admin-api/web/interview/searchPage",
    method: "GET",
    params
  });
}

// 获取部门列表
export function deptList(params) {
  return request({
    url: "/admin-api/system/dept/list-all-simple",
    method: "GET",
    params
  });
}

// hr-管理分页
export function userPage(params) {
  return request({
    url: "/admin-api/system/user/page",
    method: "GET",
    params
  });
}

//获取协议
export function GetReiMen(params) {
  return request({
    url: '/admin-api/web/about/list',
    method: 'get',
    params
  })
}

// hr-修改状态
export function hrUpdateStatus(data) {
  return request({
    url: "/admin-api/system/user/update-status",
    method: "put",
    data
  });
}

// 通知中心分页
export function notifyMessage(params) {
  return request({
    url: "/admin-api/system/notify-message/my-pages",
    method: "GET",
    params
  });
}

// 通知中心--设置已读
export function notifyMessageUpdateRead(data) {
  return request({
    url: `/admin-api/system/notify-message/update-reads?ids=${data.id}`,
    method: "PUT",
    data
  });
}

// 人才管理列表
export function talentPage(params) {
  return request({
    url: "/admin-api/web/talent/page",
    method: "GET",
    params
  });
}

//职位中心 - 发布职位
export function positioncreate(data) {
  return request({
    url: '/admin-api/web/position/create',
    method: 'POST',
    data
  })
}
//人才管理 - 修改状态
export function setupdate(data) {
  return request({
    url: '/admin-api/web/talent/update',
    method: 'put',
    data
  })
}

//面试邀请-邀请列表
export function getinterviewPage(params) {
  return request({
    url: '/admin-api/web/seekers/interviewPage',
    method: 'GET',
    params
  })
}

//面试邀请-求职者简历详情
export function getdetails(params) {
  return request({
    url: '/admin-api/web/seekers/getResExp',
    method: 'GET',
    params
  })
}

//获取多组简历
export function getdetails1(params) {
  return request({
    url: '/admin-api/web/seekers/getResExps',
    method: 'GET',
    params
  })
}

//获取字典数据
export function getedu(params) {
  return request({
    url: '/admin-api/system/dict-data/page',
    method: 'GET',
    params
  })
}

//我的企业-更新企业
export function setqiye(data) {
  return request({
    url: '/admin-api/web/enter/update',
    method: 'put',
    data
  })
}

//面试邀请 - 面试
export function mianshi(data) {
  return request({
    url: '/admin-api/web/interview/create',
    method: 'POST',
    data
  })
}

export function isim(params) {			
	// console.log(data,444444444444,data['signature']);
	return request({

		url: '/admin-api/web/s-admin/get',
		method: 'get',
		params,
		noLoad: true
		// ,aiyouee:true
	})
}


export function changim(params) {			
	// console.log(data,444444444444,data['signature']);
	return request({
// ?id=${data.id}
		url: `/admin-api/web/s-admin/updates`,
		method: 'get',
		// data,
		params,
		noLoad: true
		// ,aiyoue:true
	})
}

export function getusersig(params) {			
	// console.log(data,444444444444,data['signature']);
	return request({

		url: '/admin-api/web/s-admin/gets',
		method: 'get',
		params,
		noLoad: true
		// ,aiyouee:true
	})
}

//留言列表
export function getmeassg(params) {
  return request({
    url: '/admin-api/web/comment/page',
    method: 'GET',
    params,
    noLoad:true
  })
}
// 获取字典
export function getnature(params) {
  return request({
    url: '/admin-api/web/zidian/page',
    method: 'GET',
    params,
    noLoad:true
  })
}
// /admin-api/web/department/page
export function getnatures(params) {
  return request({
    url: '/admin-api/web/department/pageas',
    method: 'GET',
    params,
    noLoad:true
  })
}
//hr - 新增
export function AddHr(data) {
  return request({
    url: '/admin-api/system/user/create',
    method: 'POST',
    data,
    noLoad:true
  })
}

// hr-修改
export function userUpdate(data) {
  return request({
    url: "/admin-api/system/user/update",
    method: "PUT",
    data
  });
}

// hr-删除
export function userDelete(params) {
  return request({
    url: "/admin-api/system/user/delete",
    method: "delete",
    params
  });
}

// hr-重置密码
export function userUpdatePassword(data) {
  return request({
    url: "/admin-api/system/user/update-password",
    method: "PUT",
    data
  });
}

//首页-面试列表数据
export function getinterview(params) {
  return request({
    url: '/admin-api/web/interview/pagess',
    method: 'GET',
    params
  })
}

//注册验证码
export function getverification(data) {
  return request({
    url: '/admin-api/system/tenant/creates',
    method: 'post',
    data
  })
}

//留言新增
export function msgcraet(data) {
  return request({
    url: '/admin-api/web/comment/create',
    method: 'post',
    data
  })
}

//获取面试信息详情
export function getmianshiifno(params) {
  return request({
    url: '/admin-api/web/interview/gets',
    method: 'get',
    params
  })
}

//获取HR新增验证码
export function getsocde(data) {
  return request({
    url: '/admin-api/web/s-admin/send-sms-code',
    method: 'post',
    data
  })
}

// 获得职称评审分页
export function titleReviewPage(params) {
  return request({
    url: "/admin-api/web/title-review/page",
    method: "GET",
    params
  });
}

// 获得职称评审
export function titleReviewGet(params) {
  return request({
    url: "/admin-api/web/title-review/get",
    method: "GET",
    params
  });
}

// 创建职称评审
export function titleReviewCreate(data) {
  return request({
    url: "/admin-api/web/title-review/create",
    method: "POST",
    data
  });
}


// 创建职称评审
export function titleReviewCreates(data) {
  return request({
    url: "/admin-api/web/skill-recognition/create",
    method: "POST",
    data
  });
}

// 更新职称评审
export function titleReviewUpdates(data) {
  return request({
    url: "/admin-api/web/skill-recognition/update",
    method: "PUT",
    data
  });
}


// 更新职称评审
export function titleReviewUpdate(data) {
  return request({
    url: "/admin-api/web/title-review/update",
    method: "PUT",
    data
  });
}

// 删除职称评审
export function titleReviewDelete(params) {
  return request({
    url: "/admin-api/web/title-review/delete",
    method: "delete",
    params
  });
}

// 获得职称评审tab分页
export function titleReviewTabPage(params) {
  return request({
    url: "/admin-api/web/title-review-tab/page",
    method: "GET",
    params
  });
}

// 获得职称评审tab
export function titleReviewTabGet(params) {
  return request({
    url: "/admin-api/web/title-review-tab/get",
    method: "GET",
    params
  });
}

// 创建职称评审tab
export function titleReviewTabCreate(data) {
  return request({
    url: "/admin-api/web/title-review-tab/create",
    method: "POST",
    data
  });
}

// 更新职称评审tab
export function titleReviewTabUpdate(data) {
  return request({
    url: "/admin-api/web/title-review-tab/update",
    method: "PUT",
    data
  });
}

// 删除职称评审tab
export function titleReviewTabDelete(params) {
  return request({
    url: "/admin-api/web/title-review-tab/delete",
    method: "delete",
    params
  });
}

// 获得职称评审申报材料分页
export function titleReviewAttachPage(params) {
  return request({
    url: "/admin-api/web/title-review-attach/page",
    method: "GET",
    params
  });
}

// 获得职称评审申报材料
export function titleReviewAttachGet(params) {
  return request({
    url: "/admin-api/web/title-review-attach/get",
    method: "GET",
    params
  });
}

// 创建职称评审申报材料
export function titleReviewAttachCreate(data) {
  return request({
    url: "/admin-api/web/title-review-attach/create",
    method: "POST",
    data
  });
}

// 更新职称评审申报材料
export function titleReviewAttachUpdate(data) {
  return request({
    url: "/admin-api/web/title-review-attach/update",
    method: "PUT",
    data
  });
}

// 删除职称评审申报材料
export function titleReviewAttachDelete(params) {
  return request({
    url: "/admin-api/web/title-review-attach/delete",
    method: "delete",
    params
  });
}

// 获得职称评审申报记录分页
export function titleReviewRecordPage(params) {
  return request({
    url: "/admin-api/web/title-review-record/page",
    method: "GET",
    params
  });
}

// 获得职称评审申报记录分页
export function titleReviewRecordPages(params) {
  return request({
    url: "/admin-api/web/skill-recognition/page",
    method: "GET",
    params
  });
}

// 获得职称评审申报记录
export function titleReviewRecordGet(params) {
  return request({
    url: "/admin-api/web/title-review-record/get",
    method: "GET",
    params
  });
}

// 创建职称评审申报记录
export function titleReviewRecordCreate(data) {
  return request({
    url: "/admin-api/web/title-review-record/create",
    method: "POST",
    data
  });
}

// 更新职称评审申报记录
export function titleReviewRecordUpdate(data) {
  return request({
    url: "/admin-api/web/title-review-record/update",
    method: "PUT",
    data
  });
}

// 删除职称评审申报记录
export function titleReviewRecordDelete(params) {
  return request({
    url: "/admin-api/web/title-review-record/delete",
    method: "delete",
    params
  });
}
// 删除职称评审申报记录
export function titleReviewRecordDeletes(params) {
  return request({
    url: "/admin-api/web/skill-recognition/delete",
    method: "delete",
    params
  });
}

// 删除三项岗位-报名资料
export function postResourceDelete(params) {
  return request({
    url: "/admin-api/web/post-resource/delete",
    method: "delete",
    params
  });
}

// 创建三项岗位-报名资料
export function postResourceCreate(data) {
  return request({
    url: "/admin-api/web/post-resource/create",
    method: "POST",
    data
  });
}

// 更新三项岗位-报名资料
export function postResourceUpdate(data) {
  return request({
    url: "/admin-api/web/post-resource/update",
    method: "PUT",
    data
  });
}

// 创建三项岗位-栏目简介
export function postIntroductionCreate(data) {
  return request({
    url: "/admin-api/web/post-introduction/create",
    method: "POST",
    data
  });
}




// 获得三项岗位-报名资料
export function postResourceGet(params) {
  return request({
    url: "/admin-api/web/post-resource/get",
    method: "GET",
    params
  });
}


// 获得三项岗位-报名资料分页
export function postResourceList(params) {
  return request({
    url: "/admin-api/web/post-resource/page",
    method: "GET",
    params
  });
}

// 获得三项岗位-栏目简介
export function postIntroductionGet(params) {
  return request({
    url: "/admin-api/web/post-introduction/get",
    method: "GET",
    params
  });
}

// 获得三项岗位-报名资料-子分类分页
export function postSubtypeList(params) {
  return request({
    url: "/admin-api/web/post-subtype/page",
    method: "GET",
    params
  });
}

// 字典-dictType:类型
export function dictDataPage(params, noLoading) {
  return request({
    url: "/admin-api/system/dict-data/page",
    method: "GET",
    params,
    noLoading
  });
}

// 获得三项岗位-栏目简介分页
export function postIntroductionList(params) {
  return request({
    url: "/admin-api/web/post-introduction/page",
    method: "GET",
    params
  });
}

// 创建三项岗位-报名资料-子分类
export function postSubtypeCreate(data) {
  return request({
    url: "/admin-api/web/post-subtype/create",
    method: "POST",
    data
  });
}


// 更新三项岗位-栏目简介
export function postIntroductionUpdate(data) {
  return request({
    url: "/admin-api/web/post-introduction/update",
    method: "PUT",
    data
  });
}

// 删除三项岗位-栏目简介
export function postIntroductionDelete(params) {
  return request({
    url: "/admin-api/web/post-introduction/delete",
    method: "delete",
    params
  });
}

// 获得人才培养-课程专栏分页
export function courseList(params) {
  return request({
    url: "/admin-api/web/course/page",
    method: "GET",
    params
  });
}

// 获得人才培养-课程专栏
export function courseGet(params) {
  return request({
    url: "/admin-api/web/course/get",
    method: "GET",
    params
  });
}

// 创建人才培养-课程专栏
export function courseCreate(data) {
  return request({
    url: "/admin-api/web/course/create",
    method: "POST",
    data
  });
}

// 更新人才培养-课程专栏
export function courseUpdate(data) {
  return request({
    url: "/admin-api/web/course/update",
    method: "PUT",
    data
  });
}

// 删除人才培养-课程专栏
export function courseDelete(params) {
  return request({
    url: "/admin-api/web/course/delete",
    method: "delete",
    params
  });
}

// 获得同等学力分页
export function enrollList(params) {
  return request({
    url: "/admin-api/web/enroll/page",
    method: "GET",
    params
  });
}

// 获得同等学力
export function enrollGet(params) {
  return request({
    url: "/admin-api/web/enroll/get",
    method: "GET",
    params
  });
}

// 创建同等学力
export function enrollCreate(data) {
  return request({
    url: "/admin-api/web/enroll/create",
    method: "POST",
    data
  });
}

// 更新同等学力
export function enrollUpdate(data) {
  return request({
    url: "/admin-api/web/enroll/update",
    method: "PUT",
    data
  });
}

// 删除同等学力
export function enrollDelete(params) {
  return request({
    url: "/admin-api/web/enroll/delete",
    method: "delete",
    params
  });
}

// 获得继续教育分页
export function continuingEducationList(params) {
  return request({
    url: "/admin-api/web/continuing-education/page",
    method: "GET",
    params
  });
}

// 获得继续教育
export function continuingEducationGet(params) {
  return request({
    url: "/admin-api/web/continuing-education/get",
    method: "GET",
    params
  });
}

// 创建继续教育
export function continuingEducationCreate(data) {
  return request({
    url: "/admin-api/web/continuing-education/create",
    method: "POST",
    data
  });
}

// 更新继续教育
export function continuingEducationUpdate(data) {
  return request({
    url: "/admin-api/web/continuing-education/update",
    method: "PUT",
    data
  });
}

// 删除继续教育
export function continuingEducationDelete(params) {
  return request({
    url: "/admin-api/web/continuing-education/delete",
    method: "delete",
    params
  });
}

// 获得附件分页
export function attachmentPage(params) {
  return request({
    url: "/admin-api/web/attachment/page",
    method: "GET",
    params
  });
}

// 获得附件列表
export function attachmentList(params) {
  return request({
    url: "/admin-api/web/attachment/list",
    method: "GET",
    params
  });
}

// 获得附件
export function attachmentGet(params) {
  return request({
    url: "/admin-api/web/attachment/get",
    method: "GET",
    params
  });
}

// 创建附件
export function attachmentCreate(data) {
  return request({
    url: "/admin-api/web/attachment/create",
    method: "POST",
    data
  });
}

// 更新附件
export function attachmentUpdate(data) {
  return request({
    url: "/admin-api/web/attachment/update",
    method: "PUT",
    data
  });
}

// 删除附件
export function attachmentDelete(params) {
  return request({
    url: "/admin-api/web/attachment/delete",
    method: "delete",
    params
  });
}

// 获得报名详情分页
export function enrollDetailPage(params) {
  return request({
    url: "/admin-api/web/enroll-detail/page",
    method: "GET",
    params
  });
}

// 获得报名详情
export function enrollDetailGet(params) {
  return request({
    url: "/admin-api/web/enroll-detail/get",
    method: "GET",
    params
  });
}

// 创建报名详情
export function enrollDetailCreate(data) {
  return request({
    url: "/admin-api/web/enroll-detail/create",
    method: "POST",
    data
  });
}

// 更新报名详情
export function enrollDetailUpdate(data) {
  return request({
    url: "/admin-api/web/enroll-detail/update",
    method: "PUT",
    data
  });
}

// 删除报名详情
export function enrollDetailDelete(params) {
  return request({
    url: "/admin-api/web/enroll-detail/delete",
    method: "delete",
    params
  });
}


// 更新三项岗位-报名资料-子分类
export function postSubtypeUpdate(data) {
  return request({
    url: "/admin-api/web/post-subtype/update",
    method: "PUT",
    data
  });
}

// 删除三项岗位-报名资料-子分类
export function postSubtypeDelete(params) {
  return request({
    url: "/admin-api/web/post-subtype/delete",
    method: "delete",
    params
  });
}

// 获得三项岗位-报名资料-子分类
export function postSubtypeGet(params) {
  return request({
    url: "/admin-api/web/post-subtype/get",
    method: "GET",
    params
  });
}

//审核
export function putcheck(data) {
  return request({
    url: "/admin-api/web/title-review-record/check",
    method: "PUT",
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/index.js